import { render, staticRenderFns } from "./SampleWizard.vue?vue&type=template&id=6ccf73a8"
import script from "./SampleWizard.vue?vue&type=script&lang=js"
export * from "./SampleWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports